import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

enum AgentStatus {
  available = 'available',
  busy = 'busy',
  offline = 'offline',
  dnd = 'dnd',
  enabled = 'enabled',
  disabled = 'disabled'
}

@Component({
  selector: 'csh-state-icon-frame',
  templateUrl: './state-icon-frame.component.html',
  styleUrls: ['./state-icon-frame.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule]
})
export class StateIconFrameComponent implements OnChanges {
  @Input() status: AgentStatus;
  @Input() isOnline: boolean;
  @Input() width = 9;

  iconName: string;

  readonly AgentStatus = AgentStatus;

  constructor() {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes['status']) {
      this.iconName = this.generateIcon();
    }

    if (changes['isOnline']) {
      this.iconName = this.isOnline ? 'check_circle' : 'cancel';
    }
  }

  private generateIcon() {
    switch (this.status) {
      case AgentStatus.available:
      case AgentStatus.enabled:
        return 'check_circle';
      case AgentStatus.busy:
        return 'do_not_disturb_on';
      case AgentStatus.dnd:
        return 'schedule';
      case AgentStatus.offline:
      case AgentStatus.disabled:
        return 'cancel';
      default:
        return 'cancel';
    }
  }
}
